import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'ubs-icons';
import {isMobileDevice} from "../common/function";
import useResizeHeight from "../hooks/useResizeHeight";
import useWindowSize from "../hooks/useWindowSize";
import useEscKey from "../hooks/useEscKey";
import {UCustomScrollBar, useUAlert} from "../index";
import {COLOR} from "../constant";

const UModal = (props) => {
    const alert = useUAlert();
    const [open, setOpen] = useState(false);
    const [alertFlag, setAlertFlag] = useState(false);
    const ref = useRef(null);
    const size = useWindowSize();
    const scrollHeight = useResizeHeight(['u_sm-header', 'u_sm-footer']);

    useEscKey(() => {
        if (!document.querySelector('.react-datepicker-popper') && !props?.confirmationOnClose) props.onClose('esc');
    });

    useEffect(() => {
        setTimeout(() => {
            setOpen(true);
            window.dispatchEvent(new Event('resize'));
        }, 10);

        if (props?.open && isMobileDevice() && size <= 1024) {
            document.querySelector('body').style.position = 'fixed';
            document.querySelector('body').classList.add('u_w-full');
            if (document.querySelector('.u_settings-left-sidebar .u_content-header')) {
                document.querySelector('.u_settings-left-sidebar .u_content-header').style.zIndex = 0;
            }
        }

        return (() => {
            document.querySelector('body').style.position = '';
            document.querySelector('body').classList.remove('u_w-full');
            if (document.querySelector('.u_settings-left-sidebar .u_content-header')) {
                document.querySelector('.u_settings-left-sidebar .u_content-header').removeAttribute("style");
            }
        });
    }, [props?.open]);

    const handleClose = (type) => {
        if(!props?.isValidation) setTimeout(() => setOpen(false), 10);
        props.onClose(type);
    };

    const setHeight = (scrollHeightTotal) => {
        let bodyHeight = window.innerHeight < 768 ? window.innerHeight : 700;
        return {maxHeight: `calc(${bodyHeight}px - ${scrollHeightTotal}px)`}
    }
    const overlayClick = () => {
        if (props.closeOnOutsideClick) handleClose('outSide')
    }

    const handleScroll = e => {
        if (props.onScroll) props.onScroll(e)
    }

    const showAlert = e => {
        alert.show({
            title: props?.confirmationTitle,
            description: props?.confirmationDescription,
            type: 'error',
            icon: props?.icons ? props?.icons : <Icon.Delete size={36} fill={COLOR.u_red}/>,
            submit: 'Confirm',
            onSubmit: () => {
                setTimeout(() => setOpen(false), 10);
                props.onClose('icon');
            }
        });
    }

    return (
        <React.Fragment>
            <div
                ref={ref}
                className={`u_sm ${open ? 'active' : ''} ${props?.className ? props?.className : ''} ${props?.position || ''}`}
                style={{zIndex: props.zIndex}}
            >
                {/* Modal Overlay */}
                {open && <div className={`${!props?.shadow && "u_no-shadow"} u_sm-overlay`} onClick={overlayClick}/>}

                {/* Modal Content */}
                <div className="u_sm-layout" style={{maxWidth: `${typeof props.maxWidth === 'number' ? `${props.maxWidth}px` : props.maxWidth}`}}>

                    {/* Modal header */}
                    <div className="u_sm-header" id="u_sm-header">
                        <div className="u_sm-header-left">
                            {props?.header}
                        </div>

                        {!props?.hideClose && <div className="u_sm-header-right">
                            {props?.confirmationOnClose ? <div className="u_sm-close" onClick={() => showAlert()}>
                                <Icon.Close size={12} fill="#007AFF"/>
                            </div> : <div className="u_sm-close" onClick={() => handleClose('icon', false)}>
                                <Icon.Close size={12} fill="#007AFF"/>
                            </div>}
                        </div>}
                    </div>

                    {/* Modal body */}
                    {props?.customScrollbar ? <div className={`u_sm-body`}>
                            <UCustomScrollBar onScroll={handleScroll} className="u_hide-y-scroll">
                                {props.children}
                            </UCustomScrollBar>
                        </div> :
                        <div className="u_sm-body" id="u_sm-body" style={setHeight(scrollHeight)}>
                            {props.children}
                        </div>}

                    {/* Modal footer */}
                    {props.footer && <div className="u_sm-footer" id="u_sm-footer">
                        {props.footer}
                    </div>}

                </div>
            </div>
        </React.Fragment>
    );
};

UModal.propTypes = {
    children: PropTypes.node,
    maxWidth: PropTypes.number,
    open: PropTypes.bool,
    hideClose: PropTypes.bool,
    isValidation: PropTypes.bool,
    // confirmationOnClose: PropTypes.bool,
    heading: PropTypes.node,
    close: PropTypes.func,
    footerOptions: PropTypes.node,
    submitBtn: PropTypes.node,
    confirmationTitle: PropTypes.string,
    confirmationDescription: PropTypes.string
};
UModal.defaultProps = {
    children: null,
    maxWidth: 660,
    open: null,
    heading: null,
    close: null,
    footerOptions: null,
    submitBtn: null,
    shadow: true,
    hideClose: false,
    confirmationTitle: 'Something went wrong.',
    confirmationDescription: 'Are you sure want to close Import Employee sheet?',
    isValidation: false
    // confirmationOnClose: false
};
export default UModal;